import React from 'react'
import { useSelector } from 'react-redux'

const Loader = (props) => {
    const size = props.size || 'sm'
    const store = useSelector(state => state)

    return (
        <div className="content-center loader-content">
            {(Object.keys(props).includes('loading') && props.loading === 1) && <div className={`btn-loader ${size} mr-1`}></div>}
            {(!Object.keys(props).includes('loading') && store.loading === 1) && <div className={`btn-loader ${size} mr-1`}></div>}
            {/* {props.loading ? <div className={`btn-loader ${size} mr-1`}></div> : store.loading === 1 ? <div className={`btn-loader ${size} mr-1`}></div> : null} */}
            {/* {(store.loading === 1) && <div className={`btn-loader ${size} mr-1`}></div>} */}
            <span>{props.content || ''}</span>
        </div>
    )
}

export default Loader;